import CustomerList from "./components/CustomerList";
import EMPsList from "./components/EMPsList";

export const CUSTOMER_TABS = [
  { label: "Customers", path: "/customers", component: CustomerList },
  { label: "EMPs", path: "/customers/emps", component: EMPsList },
];
